/*
*   List of Actions with TYPE that should be passed from policies-and-procedure.reducer.js to documents.reducer.js
 */

export const PREFIX = 'PNP_ACCRED';

export const TYPES = {
    //FETCH_SCHEMES:                  `${PREFIX}_FETCH_SCHEMES`,
};
